import { Pipe, PipeTransform } from '@angular/core';
import { Referrer } from '../../classes/referrer';

@Pipe({
    name: 'referrerIdFilter',
    pure: false
})
export class ReferrerIdFilterPipe implements PipeTransform {
    transform(referrerList: Array<Referrer>, filterValue: string): any {
        if (!referrerList || !filterValue) {
            return referrerList;
        }
        const normalizedFilter = filterValue.toString().trim().toLowerCase();
        return referrerList.filter(referrer =>
            String(referrer.IDReferrer ?? '').toLowerCase().indexOf(normalizedFilter) !== -1
        );
    }
}
